import React, { useState, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import sessionStore from './../../stores/session';
import songbookSessionStore from './../../stores/songbookSession';
import messageStore from '../../stores/message';
import muvikaAttrs from './../../attrs';
import MuvikaService from './../../services/muvika';
import ExternalViewCommands from './../../services/external';
import { Capacitor } from '@capacitor/core';
import IntervalService from './../../services/intervals';
import ErrorDialog from '../dialogs/ErrorDialog';
import Alert from './Alert';
import TR from './../../Trans';
import accountStore from '../../stores/account';
import musicStore from '../../stores/music';
import playerStore from '../../stores/player';
import navigationStore from '../../stores/navigation';

const sessionCloseErrorCode = 2004;
const tooFewPrivileges = 2009;
const alreadyLoggedInErrorCode = 2006;
const alreadySessionOpenErrorCode = 2005;
const cancellationErrorCode = 123456789;
const cancellationSuccessCode = 1234567899;
const sessionOpenErrorCode = 1000010;
const logOnSeqErrorCode = 12345678945;
const subExpiredCode = 2012;
const serviceBreakCode = 14;
const tooManySongsErrorCode = 100003;
const networkErrorCode = 445566;
const idleTab = 12345678999;

function Error(props) {

  const session = props.isSongbook ? songbookSessionStore((state) => state.session) : sessionStore((state) => state.session);
  const openSession = props.isSongbook ? songbookSessionStore((state) => state.openSession) : sessionStore((state) => state.openSession);
  const isLoggedIn = props.isSongbook ? songbookSessionStore((state) => state.isLoggedIn) : sessionStore((state) => state.isLoggedIn);
  const isSessionOpening = props.isSongbook ? songbookSessionStore((state) => state.isSessionOpening) : sessionStore((state) => state.isSessionOpening);
  const sessionToken = props.isSongbook ? songbookSessionStore((state) => state.sessionToken) : sessionStore((state) => state.sessionToken);
  const logout = props.isSongbook ? songbookSessionStore((state) => state.logout) : sessionStore((state) => state.logout);
  const clearSession = props.isSongbook ? songbookSessionStore((state) => state.clearSession) : sessionStore((state) => state.clearSession);
  const currentError = messageStore((state) => state.currentError);
  const clearError = messageStore((state) => state.clearError);
  const setThrownOut = props.isSongbook ? songbookSessionStore((state) => state.setThrownOut) : sessionStore((state) => state.setThrownOut);
  const getAccount = accountStore((state) => state.getAccount);
  const safeArea = navigationStore((state) => state.safeArea);
  const lastShown = messageStore((state) => state.lastShown);
  const isAndroidSubMode = navigationStore((state) => state.isAndroidSubMode);

  const [errorOpen, setErrorOpen] = useState(true);
  const [errorDialogOpen, setDialogErrorOpen] = useState(true);

  const openNewSession = () => {
    console.log("isAndroidSubMode", isAndroidSubMode);
    if (!isAndroidSubMode) {
      console.log("opening session");
      const savedLang = localStorage.getItem(muvikaAttrs.service+"-session-language");
      const savedLangValue = JSON.parse(savedLang);
      clearError();
      clearSession();
      openSession(savedLangValue ? savedLangValue : "english");
    }
  };

  useEffect(function () {
    if (currentError) {
      if (currentError.sessionToken === sessionToken) {
        if (props.isSongbook) {
          if ((currentError.code == sessionCloseErrorCode && isLoggedIn) || currentError.code == tooFewPrivileges) {
            clearError();
            clearSession();
            setDialogErrorOpen(false);
            window.location.reload();
          }
        }
        if (!isLoggedIn && (currentError.code == sessionCloseErrorCode)) {
          if (!isSessionOpening) {
            openNewSession();
          }
        }
        if (currentError.code === subExpiredCode) {
          IntervalService.clearSongbookInterval();
          IntervalService.clearAllIntervals();
          IntervalService.clearSongbookPlayqueueInterval();
          musicStore.setState({ isWaiting: false, streamUrl: "", from: 0, isPaused: { isPaused: true, triggerFade: true } });
          playerStore.setState({ isStopped: { isStopped: true }, streamUrl: "" });
          getAccount(sessionToken);
        }
        if ((currentError.code == sessionCloseErrorCode && isLoggedIn) ||
          currentError.code == tooFewPrivileges ||
          currentError.code == alreadyLoggedInErrorCode ||
          currentError.code == alreadySessionOpenErrorCode ||
          currentError.code == cancellationErrorCode ||
          currentError.code == cancellationSuccessCode ||
          ((currentError.code == sessionCloseErrorCode && isLoggedIn)) ||
          currentError.code == sessionOpenErrorCode ||
          currentError.code == logOnSeqErrorCode ||
          currentError.code == tooManySongsErrorCode) {
          setDialogErrorOpen(true);
        } else {
          setErrorOpen(true);
        }
      }
    }
  }, [currentError]);

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason !== "clickaway") {
      clearError();
      setErrorOpen(false);
    }
  };

  const handleErrorAlertClose = (event, reason) => {
    clearError();
    setErrorOpen(false);
  };


  const handleDialogErrorClose = (event, reason) => {
    clearError();
    clearSession();
    setDialogErrorOpen(false);
    window.location.reload();
  };

  const handleDialogClose = (event, reason) => {
    clearError();
    setDialogErrorOpen(false);
  };

  /*   const renderTabError = () => { 
      setThrownOut(true);
      IntervalService.clearSongbookInterval();
      IntervalService.clearAllIntervals();
      IntervalService.clearSongbookPlayqueueInterval();
      return <ErrorDialog
        open={errorDialogOpen}
        onClose={() => window.location.href = muvikaAttrs.iosExternalLinkUrl}
        title={TR.cm_error}
        message={currentError.message}
      />;
    } */

  const renderSessionError = () => {
    setThrownOut(true);
    IntervalService.clearSongbookInterval();
    IntervalService.clearAllIntervals();
    IntervalService.clearSongbookPlayqueueInterval();
    return <ErrorDialog
      open={errorDialogOpen}
      onClose={handleDialogErrorClose}
      title={TR.cm_error}
      message={currentError.message}
    />;
  };

  const renderCancellationError = () => {
    IntervalService.clearSongbookInterval();
    IntervalService.clearAllIntervals();
    IntervalService.clearSongbookPlayqueueInterval();
    musicStore.setState({ isWaiting: false, isPaused: { isPaused: true, triggerFade: true } });
    playerStore.setState({ isStopped: { isStopped: true }, streamUrl: "" });
    return <ErrorDialog
      open={errorDialogOpen}
      onClose={handleDialogClose}
      title={TR.cm_order}
      message={currentError.message}
    />;
  };

  const renderCantOpenSessionError = () => {
    return <ErrorDialog
      open={errorDialogOpen}
      onClose={handleDialogClose}
      title={TR.cm_error}
      message={TR.cm_session_start_failed}
      isRetryable={true}
    />;
  };

  const renderLogOnSeqError = () => {
    return <ErrorDialog
      open={errorDialogOpen}
      onClose={() => {
        if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
          ExternalViewCommands.loadBasicToAndroidExternalScreen();
        } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
          ExternalViewCommands.loadBasicToIosExternalScreen();
        }
        logout();
        handleDialogClose();
      }}
      title={TR.cm_error}
      message={currentError.message}
      isRetryable={true}
    />;
  };

  const renderTooManySongsError = () => {
    return <ErrorDialog
      open={errorDialogOpen}
      onClose={() => {
        handleDialogClose();
      }}
      title={TR.cm_error}
      message={currentError.message}
    />;
  };

  const renderServiceBreakError = () => {
    return <ErrorDialog
      open={errorDialogOpen}
      onClose={handleDialogClose}
      title={TR.cm_error}
      message={currentError.message}
    />;
  };

  const renderSnackbar = () => {
    let isNative = Capacitor.isNativePlatform();
    return <Snackbar open={errorOpen} sx={{ zIndex: 99999999999999999, display: currentError.code == tooFewPrivileges && !isLoggedIn ? "none" : "" }} autoHideDuration={6000} onClose={handleErrorSnackbarClose} anchorOrigin={{
      vertical: isNative ? 'top' : 'bottom',
      horizontal: 'center',
    }}>
      <Alert onClose={handleErrorAlertClose} severity="error" sx={{ width: '100%', marginTop: safeArea ? safeArea.top + "px !important" : 0, marginBottom: safeArea ? safeArea.bottom + "px !important" : 0 }}>
        <b>{currentError.message}</b>
      </Alert>
    </Snackbar>;
  };

  const renderError = () => {
    console.log(currentError, isAndroidSubMode);
    if (currentError) {
      if (isAndroidSubMode) {
        clearError();
      } else {
        if (currentError.sessionToken === sessionToken) {
          if ((currentError.code == sessionCloseErrorCode && isLoggedIn) ||
            currentError.code == alreadyLoggedInErrorCode ||
            currentError.code == alreadySessionOpenErrorCode ||
            (currentError.code == tooFewPrivileges && isLoggedIn)) {
            return renderSessionError();
          } else if (currentError.code == cancellationSuccessCode ||
            currentError.code == cancellationErrorCode) {
            return renderCancellationError();
          } else if ((currentError.code == sessionCloseErrorCode && isLoggedIn) ||
            currentError.code == sessionOpenErrorCode) {
            return renderCantOpenSessionError();
          } else if (currentError.code == logOnSeqErrorCode) {
            return renderLogOnSeqError();
          } else if (currentError.code == tooManySongsErrorCode) {
            return renderTooManySongsError();
          } else if (currentError.code == serviceBreakCode) {
            return renderServiceBreakError();
          }
          if (currentError.code == networkErrorCode) {
            if (lastShown) {
              var seconds = ((new Date()).getTime() - lastShown.getTime()) / 1000;
              console.log("network error", seconds);
              if (seconds > 60) {
                return renderSnackbar();
              }
            } else {
              return renderSnackbar();
            }
          } else {
            return renderSnackbar();
          }
        }
      }
    }
  };
  return (
    <div>
      {renderError()}
    </div>
  );
}

export default Error;